export const environment = {
  apiUrl: 'https://wavezioapi.wavezio.com/api/web/v1',
  pusherUrl: 'https://api.wavezio.com/api/broadcasting/auth',
  // See environment.ts — set `enabled: false` to turn all hover help off.
  tooltips: {
    enabled: true,
    showDelayMs: 350,
    hideDelayMs: 80,
  },
  googleMapsApiKey: 'AIzaSyBA4tWGnGuAe_FMOIH8IoUc-WsArdRa0F4',
  // "AIzaSyB7dJMHVXdl1gXBDAzuyDqLHl5tXVKp9Xg",
  googleClientID:
    // "169622702538-crq97taln7ovjkginag9t88fltgrtstk.apps.googleusercontent.com",
    // '739469987983-ts9tkgndtm53ffcbg6juj2jgkgleh1p1.apps.googleusercontent.com', previous
    '739469987983-q9u9vlqmoiclep2hqa2f2hsq4a4ddc3p.apps.googleusercontent.com',
  googleClientSecret: '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',
  // "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",
  veriff_SecKey: '04c9bfbc-4208-4953-8f95-fa6c9a6ddaea',
  veriff_Key: '780929d8-f94f-46ba-8077-c1cb77c92494',
  veriff_BaseURL: 'https://stationapi.veriff.com',
  stripe_PK:
    'pk_test_51PWVRZRo7F6YokKUn8fu3QcnwgvWxXH5QJzgpXyEBXKKvJqdYgNJUI5dFAjK0H3dbQZreiMJ6BPrSIcG1qSdlph2005zd453A0',
  stripe_SK:
    'sk_test_51PWVRZRo7F6YokKUC2wVvQKxOQMwv5ZZRlJHzcLtMN7m3fE1Tn2wMXdmIqmmVtJELvjiBTTY1zX0WMW38YtISpih00E1J0WyIR',
}; //'https://homemates.roomunite.com/api/web/v1'
